export default "__VITE_ASSET__Dm8C$WLQ__"